/**
 * Races `request()` against `timeoutMs`; a valid, parsed answer replaces the current value via `set`, anything
 * else (a rejection, a timeout, a value `parse` rejects) leaves it as `get()` already has it. Never rejects.
 */
export async function loadWithFallback<T>(
  request: () => Promise<unknown>,
  parse: (raw: unknown) => T | null,
  get: () => T,
  set: (value: T) => void,
  label: string,
  timeoutMs = 3000,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const raw = await Promise.race([
      request(),
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new Error(`${label} timed out`)), timeoutMs);
      }),
    ]);
    const parsed = parse(raw);
    if (parsed) set(parsed);
  } catch {
    // the fallback stands
  } finally {
    clearTimeout(timer);
  }
  return get();
}
